import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <main
        id="MainContent"
        className="content-for-layout focus-none page- page-"
        role="main"
        tabIndex={-1}
      >
        <div className="shopify-policy__container">
          <div className="shopify-policy__title">
            <h1>Privacy policy</h1>
          </div>
          <div className="shopify-policy__body">
            <div className="rte">
              <p>
                <span style={{ fontWeight: 400 }}>
                  Merz Apothecary, Inc Privacy Policy
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  This Privacy Policy describes how your personal information is
                  collected, used, and shared when you visit or make a purchase
                  from{" "}
                </span>
                <Link onClick={toTop} to="/">
                  <span style={{ fontWeight: 400 }}>Sadiemall.site</span>
                </Link>
                <span style={{ fontWeight: 400 }}> (the “Site”).</span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  PERSONAL INFORMATION WE COLLECT
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  When you visit the Site, we automatically collect certain
                  information about your device, including information about
                  your web browser, IP address, time zone, and some of the
                  cookies that are installed on your device. Additionally, as
                  you browse the Site, we collect information about the
                  individual web pages or products that you view, what websites
                  or search terms referred you to the Site, and information
                  about how you interact with the Site. We refer to this
                  automatically-collected information as “Device Information.”
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We collect Device Information using the following
                  technologies:
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  - “Cookies” are data files that are placed on your device or
                  computer and often include an anonymous unique identifier. For
                  more information about cookies, and how to disable cookies,
                  visit{" "}
                </span>
                <Link onClick={toTop} to="/">
                  <span style={{ fontWeight: 400 }}>Home</span>
                </Link>
                <span style={{ fontWeight: 400 }}>.</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  - “Log files” track actions occurring on the Site, and collect
                  data including your IP address, browser type, Internet service
                  provider, referring/exit pages, and date/time stamps.
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  - “Web beacons,” “tags,” and “pixels” are electronic files
                  used to record information about how you browse the Site.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Additionally when you make a purchase or attempt to make a
                  purchase through the Site, we collect certain information from
                  you, including your name, billing address, shipping address,
                  payment information (including credit card numbers, email
                  address, and phone number.&nbsp; We refer to this information
                  as “Order Information.”
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  When we talk about “Personal Information” in this Privacy
                  Policy, we are talking both about Device Information and Order
                  Information.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  HOW DO WE USE YOUR PERSONAL INFORMATION?
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We use the Order Information that we collect generally to
                  fulfill any orders placed through the Site (including
                  processing your payment information, arranging for shipping,
                  and providing you with invoices and/or order
                  confirmations).&nbsp; Additionally, we use this Order
                  Information to:
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>Communicate with you;</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Screen our orders for potential risk or fraud;&nbsp;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  When in line with the preferences you have shared with us,
                  provide you with information or advertising relating to our
                  products or services;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Respond to customer service requests;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Administer your account;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Conduct research and analysis;
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Display content based upon your interests
                </span>
              </p>
              <p>
                <br />
                <br />
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We use the Device Information that we collect to help us
                  screen for potential risk and fraud (in particular, your IP
                  address), and more generally to improve and optimize our Site
                  (for example, by generating analytics about how our customers
                  browse and interact with the Site, and to assess the success
                  of our marketing and advertising campaigns).
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  SHARING YOUR PERSONAL INFORMATION
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We share your Personal Information with third parties to help
                  us use your Personal Information, as described above.&nbsp;
                  For example, we use Shopify to power our online store--you can
                  read more about how Shopify uses your Personal Information
                  here:&nbsp;{" "}
                </span>
                <Link
                  onClick={toTop}
                  to="https://www.shopify.com/legal/privacy"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://www.shopify.com/legal/privacy
                  </span>
                </Link>
                <span style={{ fontWeight: 400 }}>
                  .&nbsp; We also use Google Analytics to help us understand how
                  our customers use the Site--you can read more about how Google
                  uses your Personal Information here:&nbsp;{" "}
                </span>
                <Link
                  onClick={toTop}
                  to="https://www.google.com/intl/en/policies/privacy/"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://www.google.com/intl/en/policies/privacy/
                  </span>
                </Link>
                <span style={{ fontWeight: 400 }}>
                  .&nbsp; You can also opt-out of Google Analytics here:&nbsp;{" "}
                </span>
                <Link
                  onClick={toTop}
                  to="https://tools.google.com/dlpage/gaoptout"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://tools.google.com/dlpage/gaoptout
                  </span>
                </Link>
                <span style={{ fontWeight: 400 }}>.</span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Rakuten Advertising may collect personal information when you
                  interact with our digital property, including IP addresses,
                  digital identifiers, information about your web browsing and
                  app usage and how you interact with our properties and ads for
                  a variety of purposes, such as personalization of offers or
                  advertisements, analytics about how you engage with websites
                  or ads and other commercial purposes. For more information
                  about the collection, use and sharing of your personal data
                  and your rights, please use the below links.
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>Rakuten Advertising</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Privacy Policy :
                  https://rakutenadvertising.com/legal-notices/services-privacy-policy/
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>Your Rights : </span>
                <Link onClick={toTop} to="/">
                  <span style={{ fontWeight: 400 }}>Home</span>
                </Link>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Finally, we may also share your Personal Information to comply
                  with applicable laws and regulations, to respond to a
                  subpoena, search warrant or other lawful request for
                  information we receive, or to otherwise protect our rights.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>BEHAVIOURAL ADVERTISING</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  As described above, we use your Personal Information to
                  provide you with targeted advertisements or marketing
                  communications we believe may be of interest to you.&nbsp; For
                  more information about how targeted advertising works, you can
                  visit the Network Advertising Initiative’s (“NAI”) educational
                  page at{" "}
                </span>
                <Link onClick={toTop} to="/">
                  <span style={{ fontWeight: 400 }}>Home</span>
                </Link>
                <span style={{ fontWeight: 400 }}>.</span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  You can opt out of or change the settings of targeted
                  advertising in your services’ settings::
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>FACEBOOK - </span>
                <Link
                  onClick={toTop}
                  to="https://www.facebook.com/settings/?tab=ads"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://www.facebook.com/settings/?tab=ads
                  </span>
                </Link>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>GOOGLE - </span>
                <Link
                  onClick={toTop}
                  to="https://www.google.com/settings/ads/anonymous"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://www.google.com/settings/ads/anonymous
                  </span>
                </Link>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>BING - </span>
                <Link
                  onClick={toTop}
                  to="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
                >
                  <span style={{ fontWeight: 400 }}>
                    https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                  </span>
                </Link>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  TIK TOK -&nbsp;https://www.tiktok.com/safety/en/ads-and-data/
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Additionally, you can opt out of some of these services by
                  visiting the Digital Advertising Alliance’s opt-out portal
                  at:&nbsp;{" "}
                </span>
                <Link onClick={toTop} to="/">
                  <span style={{ fontWeight: 400 }}>Home</span>
                </Link>
                <span style={{ fontWeight: 400 }}>.</span>
              </p>
              <p>&nbsp;</p>
              <p>
                When you visit or log in to our website, cookies and similar
                technologies may be used by our online data partners or vendors
                to associate these activities with other personal information
                they or others have about you, including by association with
                your email or home address. We (or service providers on our
                behalf) may then send communications and marketing to these
                email or home addresses. You may opt out of receiving this
                advertising by visiting&nbsp;
                <Link onClick={toTop} to="/">
                  Home
                </Link>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>DO NOT TRACK</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Please note that we do not alter our Site’s data collection
                  and use practices when we see a Do Not Track signal from your
                  browser.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  EUROPEAN RESIDENT RIGHTS
                </span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  If you are a European resident, you have the right to access
                  personal information we hold about you and to ask that your
                  personal information be corrected, updated, or deleted. If you
                  would like to exercise this right, please contact us through
                  the contact information below.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Additionally, if you are a European resident we note that we
                  are processing your information in order to fulfill contracts
                  we might have with you (for example if you make an order
                  through the Site), or otherwise to pursue our legitimate
                  business interests listed above.&nbsp; Additionally, please
                  note that your information will be transferred outside of
                  Europe, including to Canada and the United States.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>DATA RETENTION</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  When you place an order through the Site, we will maintain
                  your Order Information for our records unless and until you
                  ask us to delete this information.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>CHANGES</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We may update this privacy policy from time to time in order
                  to reflect, for example, changes to our practices or for other
                  operational, legal or regulatory reasons.
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>CONTACT US</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  For more information about our privacy practices, if you have
                  questions, or if you would like to make a complaint, please
                  contact us by e-mail at find@sadiemall.site or by mail using
                  the details provided below:
                </span>
              </p>
              <p>&nbsp;</p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  &nbsp;4716 N Lincoln Ave, Chicago, IL, 60625, United States
                </span>
              </p>
              <p>
                <br />
              </p>
              <p>
                <b>Text Marketing &amp; Notifications</b>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  We value your privacy and the information you consent to share
                  in relation to our SMS marketing service. We use this
                  information to send you text notifications (for your order,
                  including abandoned checkout reminders), text marketing
                  offers, and transactional texts, including requests for
                  reviews from us.
                </span>
                <span style={{ fontWeight: 400 }}>&nbsp;</span>
              </p>
              <p>
                <span style={{ fontWeight: 400 }}>
                  Our website uses cookies to keep track of items you put into
                  your shopping cart, including when you have abandoned your
                  checkout. This information is used to determine when to send
                  cart reminder messages via SMS.
                </span>
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </body>
  );
}

export default Privacy;
